import { render, staticRenderFns } from "./LinkPage.vue?vue&type=template&id=7730236f&scoped=true"
import script from "./LinkPage.vue?vue&type=script&lang=ts"
export * from "./LinkPage.vue?vue&type=script&lang=ts"
import style0 from "./LinkPage.vue?vue&type=style&index=0&id=7730236f&prod&lang=scss&scoped=true"
import style1 from "./LinkPage.vue?vue&type=style&index=1&id=7730236f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7730236f",
  null
  
)

export default component.exports